import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_SCA_LABEL,
  EVENTS_AWARDS_SCA_PATH,
} from "@events-awards/utils/constants";
import {
  getStaticPageTitle,
  SCAStaticPageFactory,
} from "@events-awards/utils/helpers";
import { AwardType } from "@events-awards/utils/types";
import SCAFooter from "@sca/components/SCAFooterComponents/SCAFooter";
import { useDetectAdBlock } from "adblock-detect-react";

type SCAStaticPageProps = {
  /** The url string to get url at SCA static page. */
  urlPath: string;
};

/**
 * Component to render SCA static navigation pages
 */
const SCAStaticPage = ({ urlPath }: SCAStaticPageProps): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  const StaticLayout = SCAStaticPageFactory(urlPath);

  return (
    <div className="w-full" data-testid="sca-static-page-component">
      <AdSettings
        adNames={["lb1", "prestitial", "catfish"]}
        path={EVENTS_AWARDS_SCA_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Singapore Corporate Awards"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={getStaticPageTitle(urlPath) + "  - THE BUSINESS TIMES"}
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_SCA_LABEL} - Find ${EVENTS_AWARDS_SCA_LABEL} News & Headlines, insight and analysis in Singapore, ASCA-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_SCA_PATH}
      />

      <EventsAwardsHeader />

      <Container rootClassName="pb-8 w-full justify-center px-3 text-left text-gray-850">
        <EventsAwardsNavigationBar awardType={AwardType.SCA} />

        <>{StaticLayout ? <StaticLayout /> : null}</>
      </Container>

      <SCAFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default SCAStaticPage;
